module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Thumbtack-2936cb58bbff8c7148d74f0ab4ec12cb.svg";